import { isGlobalworth, paths } from 'config'
import { DrawerUsers, Users } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.users,
    admin: false,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Users : DrawerUsers,
      label: 'nav.users',
    },
    component: Loadable({
      component: () => import('./pages/Users'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.addUser,
    admin: false,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AddUsers'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.user,
    admin: false,
    exact: true,
    component: Loadable({
      component: () => import('./pages/User'),
    }),
    layoutSettings: {},
  },
]

export default routes
